// src/index.ts
function formPayload(input) {
  const payload = {};
  for (const [key, value] of Object.entries(input)) {
    if (value !== null && value !== void 0) payload[key] = value;
  }
  return payload;
}
function mapFormRecordToApiRequest(input, requestSchema) {
  return requestSchema.parse(formPayload(input));
}
function makeFormAdapter(requestSchema) {
  return {
    formSchema: requestSchema,
    mapFormToApi: (input) => mapFormRecordToApiRequest(input, requestSchema)
  };
}

export { formPayload, makeFormAdapter, mapFormRecordToApiRequest };
//# sourceMappingURL=index.mjs.map
//# sourceMappingURL=index.mjs.map